module.exports = __webpack_public_path__ + "media/images/official-7-5391b3d7bc4ec661c2d5a2e48dafd19e.png";